// RBC 27-sep-2026 \u2014 Ficha de producto caf\u00e9 R\u00fcbra (sections/rubra-coffee.liquid)
(function () {
  function init(root) {
    if (root.dataset.rcfReady) return;
    root.dataset.rcfReady = '1';

    var variants = [];
    try { variants = JSON.parse(root.querySelector('.rcf-variants').textContent); } catch (e) {}
    var currency = root.dataset.currency || 'EUR';
    var locale = root.dataset.locale || 'es-ES';
    var kgFactor = parseFloat(root.dataset.kgFactor) || 4;
    var bisForm = root.dataset.bisForm;

    var form = root.querySelector('[data-rcf-form]');
    var input = root.querySelector('[data-rcf-variant-input]');
    var qtyInput = root.querySelector('[data-rcf-qty-input]');
    var atc = root.querySelector('[data-rcf-atc]');
    var notify = root.querySelector('[data-rcf-notify]');
    var status = root.querySelector('[data-rcf-status]');
    var prices = root.querySelectorAll('[data-rcf-price]');
    var unit = root.querySelector('[data-rcf-unit]');
    var choices = Array.prototype.slice.call(root.querySelectorAll('.rcf-choice'));
    var mbar = root.querySelector('[data-rcf-mbar]');
    var mbarBtn = root.querySelector('[data-rcf-mbar-btn]');
    var buy = root.querySelector('.rcf-buy');

    var current = variants.find(function (v) { return String(v.id) === String(input.value); }) || variants[0];
    var selected = current ? current.options.slice() : [];

    function money(c) { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(c / 100); }

    function refresh() {
      choices.forEach(function (b) {
        var i = +b.dataset.rcfIndex, val = b.dataset.rcfValue;
        var match = variants.filter(function (v) {
          return v.options[i] === val && selected.every(function (s, j) { return j === i || v.options[j] === s; });
        });
        var on = selected[i] === val;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-soldout', !match.some(function (v) { return v.available; }));
      });
      current = variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); }) || null;
      if (!current) { atc.hidden = true; notify.hidden = true; status.textContent = 'No disponible'; return; }
      input.value = current.id;
      prices.forEach(function (p) { p.textContent = money(current.price); });
      if (unit) unit.textContent = money(Math.round(current.price * kgFactor));
      atc.hidden = !current.available;
      notify.hidden = current.available;
      status.textContent = current.available ? '' : 'Agotado temporalmente';
      if (mbarBtn) mbarBtn.textContent = current.available ? 'A\u00f1adir' : 'Av\u00edsame';
      if (window.history.replaceState && variants.length > 1) {
        var url = new URL(window.location.href); url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    choices.forEach(function (b) {
      b.addEventListener('click', function () { selected[+b.dataset.rcfIndex] = b.dataset.rcfValue; refresh(); });
    });

    root.querySelectorAll('[data-rcf-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.dataset.rcfQty, 10));
        qtyInput.value = n;
      });
    });

    function openBIS() {
      if (!current) return;
      window.klaviyoVariantId = current.id; window._klBISVariantId = current.id;
      var tries = 0;
      (function go() {
        if (window._klOnsite && window._klOnsite.openForm) return window._klOnsite.openForm(bisForm);
        if (window.klaviyo && window.klaviyo.openForm) return window.klaviyo.openForm(bisForm);
        if (++tries < 20) setTimeout(go, 300);
      })();
    }
    notify.addEventListener('click', openBIS);

    function refreshBubble(sections) {
      var t = document.getElementById('cart-icon-bubble'), html = sections && sections['cart-icon-bubble'];
      if (t && html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var f = d.getElementById('shopify-section-cart-icon-bubble') || d.querySelector('.shopify-section');
        if (f) { t.innerHTML = f.innerHTML; return; }
      }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        document.querySelectorAll('.cart-count-bubble').forEach(function (el) {
          el.innerHTML = '<span aria-hidden="true">' + c.item_count + '</span>'; el.classList.remove('hidden');
        });
      }).catch(function () {});
    }

    function add(btn) {
      if (!current || !current.available) return openBIS();
      var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (btn) btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: current.id, quantity: qty, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (data) {
        if (data.status && !data.sections) { status.textContent = data.description || data.message || 'No hay m\u00e1s unidades'; return; }
        status.textContent = '';
        var drawer = document.querySelector('cart-drawer');
        if (data.sections && data.sections['cart-drawer'] && drawer) {
          var doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
          var nD = doc.getElementById('CartDrawer'), cD = document.getElementById('CartDrawer');
          if (nD && cD) cD.innerHTML = nD.innerHTML;
          else { var n = doc.querySelector('cart-drawer'); if (n) drawer.innerHTML = n.innerHTML; }
          drawer.classList.remove('is-empty');
          var inner = document.querySelector('.drawer__inner'); if (inner) inner.classList.remove('is-empty');
          if (typeof drawer.open === 'function') drawer.open();
        } else if (!drawer) { window.location.href = '/cart'; return; }
        refreshBubble(data.sections);
      }).catch(function () { status.textContent = 'Error al a\u00f1adir. Int\u00e9ntalo de nuevo.'; })
        .finally(function () { if (btn) btn.classList.remove('is-loading'); });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); add(atc); });
    if (mbarBtn) mbarBtn.addEventListener('click', function () { add(mbarBtn); });

    // Barra fija m\u00f3vil: visible cuando el bloque de compra no est\u00e1 en pantalla
    if (mbar && buy && 'IntersectionObserver' in window) {
      var seenBuy = false;
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) seenBuy = true;
          var show = window.innerWidth < 990 && !e.isIntersecting && seenBuy;
          mbar.classList.toggle('is-hidden', !show);
          document.body.classList.toggle('rbc-sticky-on', show);
        });
      }, { threshold: 0 }).observe(buy);
    }

    // Puntos del carrusel m\u00f3vil
    var media = root.querySelector('.rcf-media');
    var dots = root.querySelectorAll('.rcf-dot');
    var dotsWrap = root.querySelector('.rcf-dots');
    if (media && dotsWrap) media.parentNode.insertBefore(dotsWrap, media.nextSibling);
    if (media && dots.length) {
      media.addEventListener('scroll', function () {
        var i = Math.round(media.scrollLeft / media.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
    }

    refresh();
  }

  function boot() { document.querySelectorAll('.rcf').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
